import { Component, OnInit } from '@angular/core';
import { VerskiPraznik } from './verski-praznik';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-verski-praznik-modal-update',
  templateUrl: './verski-praznik-modal-update.component.html',
})
export class VerskiPraznikModalUpdateComponent
 extends BaseModalUpdateComponent<VerskiPraznik>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VerskiPraznik>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);    
   }

  ngOnInit() {
  }

}
